import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Actions
import { setLanguage, InitLanguage, setTranslations } from '../../../language'
import { setPhoneCodes, setBrands, setEnums, setCountries } from '../../../actions/common'
import { getCompaniesFromToken, loginWithToken } from '../../../actions/embedded'

// Redux
import store from '../../../store'

// Elements
import Button from '../../../shared/elements/button'

import './embedview.scss'

class EmbedView extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'loading',    // Valid views: 'loading', 'error', 'companyselection', 'logincomplete'
      companies: []
    }
    this.setView = this.setView.bind(this)
    this.restart = this.restart.bind(this)
  }

  componentDidMount (props) {
    let lang = this.props.language
    switch (this.props.language) {
      case 'danish':
      case 'Dk':
      case 'dk':
        lang = 'Danish'
        break
      case 'english':
      case 'Uk':
      case 'uk':
      case 'En':
      case 'en':
        lang = 'English'
        break
    }
    if (typeof lang === 'string') {
      InitLanguage().then(res => {
        store.dispatch(setTranslations(res.translations))
        store.dispatch(setLanguage(lang))
        store.dispatch(setPhoneCodes(res.data.PhoneCodes))
        store.dispatch(setBrands(res.data.Brands))
        store.dispatch(setEnums(res.data.Enums))
        store.dispatch(setCountries(res.data.Countries))
      })
    }
    this.restart()
  }

  restart () {
    console.log('EmbedView -> restart 1')
    if (typeof this.props.embedToken === 'string') {
      let requireCompany = false
      let usage = 0
      switch (this.props.embedType) {
        case 'bookingportal':
          requireCompany = true
          usage = 1
      }
      if (typeof this.props.auth.user === 'object' && typeof this.props.auth.user.Token === 'string' && this.props.auth.user.Usage === usage) {
        this.setView('logincomplete')
        if (requireCompany) {
          this.props.getCompaniesFromToken(this.props.embedToken, this.props.embedType).then(res => {
            this.setState({ companies: res.data })
            if (res.data.length > 0) {
              console.log('EmbedView -> restart 3 -> onCompanyTokensReceived')
              if (typeof this.props.onCompanyTokensReceived === 'function') {
                this.props.onCompanyTokensReceived(res.data)
              }
            }
          })
        }
        if (typeof this.props.onLoginComplete === 'function') {
          this.props.onLoginComplete()
        }
        return
      }
      console.log('EmbedView -> restart 2')
      if (requireCompany) {
        this.props.getCompaniesFromToken(this.props.embedToken, this.props.embedType).then(res => {
          this.setState({ companies: res.data })
          this.setView('companyselection')
          if (res.data.length > 0) {
            console.log('EmbedView -> restart 4 -> onCompanyTokensReceived')
            if (typeof this.props.onCompanyTokensReceived === 'function') {
              this.props.onCompanyTokensReceived(res.data)
            }
          }
        }, () => {
          this.setView('error')
        })
      }
    }
  }

  componentWillReceiveProps (props) {
    if (typeof props.view !== undefined && props.view !== this.state.view && props.view !== null) {
      this.setState({ view: props.view })
    }
  }

  setView (view) {
    this.setState({ view: view }, () => {
      if (typeof this.props.onViewChange === 'function') {
        this.props.onViewChange(view)
      }
    })
  }

  loginWithToken (token) {
    this.props.loginWithToken(token, this.props.embedType).then(res => {
      this.setView('logincomplete')
      if (typeof this.props.onLoginComplete === 'function') {
        this.props.onLoginComplete()
      }
    }, () => {
      this.setState({ view: 'error' })
    })
  }

  renderCompanySelection () {
    const renderCompanyButton = (company, i) => {
      return (
        <Button style='link' key={'key_' + i} labelText={company.CompanyName} onClick={() => this.loginWithToken(company.Token)} />
      )
    }
    const renderNoAvailableCompanies = () => {
      let notAvailableMsg = 'No available companies!'
      if (typeof this.props.notAvailableMsg === 'string') notAvailableMsg = this.props.notAvailableMsg
      return (
        <div className='embedview error'>
          <p>{notAvailableMsg}</p>
        </div>
      )
    }
    if (this.state.companies === null) {
      return renderNoAvailableCompanies()
    }

    return (
      <div className='embedview company-select'>
        {this.props.children}
        <div className='companies'>
          {this.state.companies.length > 1 && this.state.companies.map(renderCompanyButton)}
        </div>
      </div>
    )
  }

  renderLoadingView () {
    return (
      <div className='embedview loading'>
        <div className='spinner'>
          <div className='fa fa-spinner fa-spin fa-3x fa-fw' />
        </div>
      </div>
    )
  }

  renderError () {
    let errorMsg = 'There seems to be a configuration error with the embedded view!'
    if (typeof this.props.configErrorMsg === 'string') errorMsg = this.props.configErrorMsg
    return (
      <div className='embedview error'>
        <div>{errorMsg}</div>
      </div>
    )
  }

  render () {
    switch (this.state.view) {
      case 'loading': return this.renderLoadingView()
      case 'error': return this.renderError()
      case 'companyselection': return this.renderCompanySelection()
    }
    return (
      <div className='embedview'>
        <div>{this.props.children}</div>
      </div>
    )
  }
}

EmbedView.propTypes = {
  embedType: PropTypes.string.isRequired,
  auth: PropTypes.object.isRequired,
  setLanguage: PropTypes.func.isRequired,
  setPhoneCodes: PropTypes.func.isRequired,
  setBrands: PropTypes.func.isRequired,
  setCountries: PropTypes.func.isRequired,
  setEnums: PropTypes.func.isRequired,
  InitLanguage: PropTypes.func.isRequired,
  loginWithToken: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  getCompaniesFromToken,
  loginWithToken,
  InitLanguage,
  setLanguage,
  setPhoneCodes,
  setBrands,
  setCountries,
  setEnums
})(EmbedView)



// WEBPACK FOOTER //
// ./src/app/shared/components/EmbedView/index.js